import React, { Fragment, PropsWithChildren } from 'react'
import { withShowIf } from '../../helpers/with-show-if/with-show-if.component'

export const ShowIfFragment = withShowIf(
  (props: PropsWithChildren<unknown>) => {
    return <Fragment>{props.children}</Fragment>
  },
)
